export default __webpack_public_path__ + "static/media/Geologica-Regular.e13272ec.ttf";